














































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import ShopeeBaseSettingList from '@/store/entities/shopeebasesetting'
import DateUtils from '@/common/js/DateUtils'
import ChannelList from '@/store/entities/channelmaintain'

@Component
export default class EditShopeeBaseSetting extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    baseSetting: ShopeeBaseSettingList = new ShopeeBaseSettingList();
    AuthorizeCategoryTypeList = [{ id: 0, title: "个人" }, { id: 1, title: "企业" }, { id: 2, title: "永久" }, { id: 3, title: "体验用户" }];
    selectDate: string = "";
    selectTime: string = "";
    Channel: Array<ChannelList> = [];
    ChannelSelect: Array<ChannelList> = [];
    async save() {
        if (this.baseSetting.authorizeCategory == 0 || this.baseSetting.authorizeCategory == 1 || this.baseSetting.authorizeCategory == 3) {
            if (!this.selectDate||this.selectDate.length == 0) {
                this.$Message.error('个人，企业，体验用户授权时间不能为空!');
                return;
            } else {
                var anyDate: any = this.selectDate;
                //try {
                //    anyDate = DateUtils.formatLongDate(this.selectDate);
                //} catch (err) {
                //}
                this.baseSetting.authorizeTime =  anyDate;
            }
        }
        if (this.baseSetting.authorizeCategory == 0 || this.baseSetting.authorizeCategory == 3) {
            if (this.baseSetting.shopNumberLimit == null) {
                   this.$Message.error('个人，体验用户店铺数量不能为空!');
                   return;
            }
        }
       await this.$store.dispatch({
                    type: 'shopeebasesetting/update',
                    data: this.baseSetting
       });
       this.$emit('save-success');
       this.$emit('input', false);
    }
    cancel() {
        (this.$refs.baseSettingForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if(!value){
            this.$emit('input',value);
        }else{
            this.baseSetting = Util.extend(true, {}, this.$store.state.shopeebasesetting.editBaseSetting);
            if (this.baseSetting.authorizeTime) {
                this.selectDate =DateUtils.formatLongDate(new Date(this.baseSetting.authorizeTime));
              //  var date = new Date(this.baseSetting.authorizeTime);
               // this.selectDate = date.getFullYear() + "-" + (date.getMonth()+1 )+ "-" + date.getDate();
                //this.selectTime = date.getHours() + "-" + date.getMinutes() + "-" + date.getSeconds();
            } else {
                this.selectDate = null;
              //  this.selectTime = "";
            }
        }
    }
    baseSettingRule = {

    }

    async get() {
        await this.$store.dispatch({
            type: 'channel/getAll',
            data: {}
        });
        this.Channel = this.$store.state.channel.list;
        var _this = this;
       
        var data = this.Channel.filter(function (item) { return item.id == _this.baseSetting.channelId });
        if (data.length > 0) {
            this.baseSetting.channelId = data[0].id;
            }
        
    }
    created() {
        this.get();

    }
}
